// 관세사 — 월정산 명세 (Wave 5.2, 2026-05-29)
//   백엔드: GET /clearance-broker/settlement?companyId=&month=, POST /clearance-broker/settlement/pay
//   업체×월 완료 면장 명세(라이브) + 합계 + 입금 기록. (정산서 PDF = Wave 5.3)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
function won(n) { return (Number(n) || 0).toLocaleString('ko-KR'); }
function thisMonth() { return new Date().toISOString().slice(0, 7); }

function CustomsBrokerSettlement({ showToast, initialCompanyId }) {
  var st = showToast || function () {};
  var monthState = useState(thisMonth()); var month = monthState[0]; var setMonth = monthState[1];
  var listState = useState([]); var companyList = listState[0]; var setCompanyList = listState[1];
  var cidState = useState(initialCompanyId || 0); var companyId = cidState[0]; var setCompanyId = cidState[1];
  var settleState = useState(null); var settle = settleState[0]; var setSettle = settleState[1];
  var payState = useState(''); var payInput = payState[0]; var setPayInput = payState[1];

  // 업체 드롭다운 목록
  useEffect(function () {
    authFetch(API + '/clearance-broker/companies?month=' + encodeURIComponent(month))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) {
          setCompanyList(d.companies || []);
          if (!companyId && d.companies && d.companies.length) setCompanyId(d.companies[0].id);
        }
      }).catch(function () {});
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [month]);

  function loadSettle() {
    if (!companyId) { setSettle(null); return; }
    authFetch(API + '/clearance-broker/settlement?companyId=' + companyId + '&month=' + encodeURIComponent(month))
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { setSettle(d); setPayInput(String(d.paidAmount || d.total || 0)); } else { setSettle(null); st((d && d.error) || '조회 실패', 'err'); } })
      .catch(function () { setSettle(null); });
  }
  useEffect(function () { loadSettle(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [companyId, month]);

  function recordPay() {
    authFetch(API + '/clearance-broker/settlement/pay', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ companyId: companyId, month: month, paidAmount: Number(payInput) || 0 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st(d.status === 'paid' ? '완납 처리됨' : '입금 기록됨', ''); loadSettle(); } else st((d && d.error) || '기록 실패', 'err'); })
      .catch(function () { st('기록 실패', 'err'); });
  }
  // 정산 확정(청구) — 스냅샷 동결 + 업체에 정산서 발행 알림
  function confirmSettle() {
    if (!settle || settle.count === 0) return;
    if (!window.confirm(settle.company.name + ' ' + month + ' 정산을 확정·청구할까요? (₩' + (Number(settle.total) || 0).toLocaleString('ko-KR') + ', ' + settle.count + '건) 업체에 정산서 발행 알림이 전송됩니다.')) return;
    authFetch(API + '/clearance-broker/settlement/confirm', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ companyId: companyId, month: month }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('정산 확정·업체 알림 전송됨', ''); loadSettle(); } else st((d && d.error) || '확정 실패', 'err'); })
      .catch(function () { st('확정 실패', 'err'); });
  }
  // 재정산 — 확정 후 추가된 면장을 현재 기준으로 재동결 (청구건이면 업체 재알림)
  function resettle() {
    if (!settle) return;
    if (!window.confirm('현재 면장 기준으로 재정산할까요? 청구액이 ' + (Number(settle.liveTotal) || 0).toLocaleString('ko-KR') + '원으로 갱신됩니다.' + (settle.issued ? ' 업체에 변경 알림이 전송됩니다.' : ''))) return;
    authFetch(API + '/clearance-broker/settlement/resettle', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ companyId: companyId, month: month }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('재정산 완료', ''); loadSettle(); } else st((d && d.error) || '재정산 실패', 'err'); })
      .catch(function () { st('재정산 실패', 'err'); });
  }
  // 정산서/명세 다운로드 — authFetch→blob (JWT 필요 엔드포인트)
  function downloadBlob(path, filename, errMsg) {
    if (!companyId) return;
    authFetch(API + path)
      .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.blob(); })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = filename;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000);
      }).catch(function () { st(errMsg, 'err'); });
  }
  function downloadPdf() {
    downloadBlob('/clearance-broker/settlement/pdf?companyId=' + companyId + '&month=' + encodeURIComponent(month), '면장정산서_' + ((settle && settle.company.name) || '') + '_' + month + '.pdf', 'PDF 생성 실패');
  }
  function downloadExcel() {
    downloadBlob('/clearance-broker/settlement/export?companyId=' + companyId + '&month=' + encodeURIComponent(month), '면장정산명세_' + ((settle && settle.company.name) || '') + '_' + month + '.xlsx', '엑셀 생성 실패');
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
        <select value={companyId} onChange={function (e) { setCompanyId(Number(e.target.value)); }} style={{ padding: '7px 12px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13, minWidth: 160 }}>
          <option value={0}>{'업체 선택'}</option>
          {companyList.map(function (c) { return <option key={c.id} value={c.id}>{c.name}</option>; })}
        </select>
        <input type="month" value={month} onChange={function (e) { setMonth(e.target.value); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13 }} />
      </div>

      {!settle && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>{'업체와 월을 선택하세요'}</div>}
      {settle && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 16px', marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{settle.company.name}</div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{(settle.company.ceo ? '담당: ' + settle.company.ceo + '  ·  ' : '') + (settle.company.tel || '')}</div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{settle.month + ' · 면장 ' + settle.count + '건 · 수수료율 ' + settle.rate + '%'}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 12, color: '#64748b' }}>{'정산 합계'}</div>
              <div style={{ fontSize: 24, fontWeight: 900, color: NAVY }}>{won(settle.total) + '원'}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'flex-end', marginTop: 4, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: settle.status === 'paid' ? '#16a34a' : (settle.issued ? '#2563eb' : '#ea580c'), borderRadius: 10, padding: '2px 10px' }}>{settle.status === 'paid' ? '완납' : (settle.issued ? '🔒 청구됨' + (settle.issuedDate ? ' ' + settle.issuedDate : '') : '미정산')}</span>
                {!settle.issued && settle.status !== 'paid' && <button onClick={confirmSettle} disabled={settle.count === 0} style={{ padding: '5px 12px', background: settle.count === 0 ? '#cbd5e1' : '#2563eb', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: settle.count === 0 ? 'not-allowed' : 'pointer' }}>{'✅ 정산 확정·청구'}</button>}
                <button onClick={downloadExcel} disabled={settle.count === 0} style={{ padding: '5px 12px', background: settle.count === 0 ? '#cbd5e1' : '#16a34a', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: settle.count === 0 ? 'not-allowed' : 'pointer' }}>{'📊 엑셀'}</button>
                <button onClick={downloadPdf} disabled={settle.count === 0} style={{ padding: '5px 12px', background: settle.count === 0 ? '#cbd5e1' : NAVY, color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: settle.count === 0 ? 'not-allowed' : 'pointer' }}>{'📄 정산서 PDF'}</button>
              </div>
            </div>
          </div>

          {settle.drift > 0 && (
            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '10px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13, color: '#92400e' }}>{'⚠️ 정산 확정 후 면장 ' + settle.driftCount + '건(₩' + won(settle.drift) + ') 추가됨 — 청구액은 확정 시점(₩' + won(settle.total) + ') 기준 동결입니다.'}</span>
              <button onClick={resettle} style={{ padding: '6px 14px', background: '#d97706', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>{'재정산 (₩' + won(settle.liveTotal) + ')'}</button>
            </div>
          )}

          <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10, marginBottom: 12 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
              <thead><tr style={{ background: '#f8fafc' }}>
                <th style={thS}>{'완료일'}</th><th style={thS}>{'차량번호'}</th><th style={thS}>{'차대번호'}</th><th style={thS}>{'면장번호'}</th>
                <th style={thRight}>{'인보이스 금액'}</th><th style={thRight}>{'수수료'}</th>
              </tr></thead>
              <tbody>
                {settle.lines.length === 0 && <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: '#94a3b8' }}>{'해당 월 완료 면장이 없습니다'}</td></tr>}
                {settle.lines.map(function (l) {
                  return (
                    <tr key={l.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                      <td style={tdS}>{l.completedDate}</td>
                      <td style={Object.assign({ fontWeight: 600 }, tdS)}>{l.carNo}</td>
                      <td style={Object.assign({ fontFamily: 'monospace', fontSize: 11, color: '#64748b' }, tdS)}>{(l.vin || '').slice(-6)}</td>
                      <td style={tdS}>{l.exportDecNo || '-'}</td>
                      <td style={tdRight}>{won(l.invoiceAmount)}</td>
                      <td style={Object.assign({ fontWeight: 700 }, tdRight)}>{won(l.fee)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 16px' }}>
            <span style={{ fontSize: 13, color: '#475569', fontWeight: 600 }}>{'입금액'}</span>
            <input type="number" value={payInput} onChange={function (e) { setPayInput(e.target.value); }} style={{ width: 140, padding: '6px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13, textAlign: 'right' }} />
            <span style={{ fontSize: 12, color: '#64748b' }}>{'원'}</span>
            <button onClick={recordPay} style={{ padding: '7px 18px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'입금 기록'}</button>
            {settle.paidDate && <span style={{ fontSize: 12, color: '#64748b' }}>{'최근 입금: ' + settle.paidDate + ' · ' + won(settle.paidAmount) + '원'}</span>}
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thRight = Object.assign({}, thS, { textAlign: 'right' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdRight = Object.assign({}, tdS, { textAlign: 'right' });

export default CustomsBrokerSettlement;
